export default "__VITE_ASSET__9d450adf__"